(function () {
  ("use strict");
  /*============================================================================
    Start Func
  ==============================================================================*/
  ThemeFunc.Currency = {
    formatMoney: function (cents, format) {
      if (!format) {
        format = ThemeFunc.settings.moneyFormat;
      }

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = ThemeFunc.Utils.defaultTo(precision, 2);
        thousands = ThemeFunc.Utils.defaultTo(thousands, ',');
        decimal = ThemeFunc.Utils.defaultTo(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    },
    getBaseUnit: function (variant) {
      if (!variant) return;
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) return;
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
    }
  }
  ThemeFunc.Utils = {
    readyDOM: function (callback) {
      if (document.readyState != "loading") callback();
      else document.addEventListener("DOMContentLoaded", callback);
    },
    getSectionID: function (container) {
      return document.querySelector(container) ? document.querySelector(container).getAttribute("data-section-id") : "";
    },
    compact: function (array) {
      return array.filter((x) => !!x);
    },
    isDefined: function (obj) {
      return typeof obj == "undefined" ? false : true;
    },
    defaultTo: function (value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },
    serialize: function (form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function (option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
              '=' +
              encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
  };


  /*============================================================================
  Collection Template
==============================================================================*/
  ThemeFunc.Collection = {
    config: {
      section_id: ThemeFunc.Utils.getSectionID(".fcollection"),
    },
    selector: {
      button_open_filter: `button[data-type="open-filter"]`,
      button_close_filter: `button[data-type="close-filter"]`,
      button_clear_filter: `button[data-type="clear-filter"]`,
      button_apply_filter: `button[data-type="apply-filter"]`,
      overplay_filter: `.shop-filter-overplay`,
      modal: `Shop-Filter`,
      inputsFilter: `.shop-filter input[name*="filter"]`,
      inputsSort: `.shop-filter input[name*="sort"]`,
      forms: ".shop-filter form",
      heading_filter_items: ".shop-filter-item-head",
      product_container: ".fcollection-items",
      count_container: ".fcollection-head-count",
      load_more_container: ".fcollection-load-more",
      button_back_top: `button[data-type="back-to-top"]`,
    },
    init: function () {
      this.actions();
      this.initLoadMore();
      this.backToTop();
    },
    actions: function () {
      /* Actions for Modal */
      const filterModal = document.getElementById(
        `${this.selector.modal}-${this.config.section_id}`
      );
      document.querySelector(this.selector.button_open_filter).addEventListener("click", () => {
        filterModal.classList.add("active");
      });

      document.querySelector(this.selector.button_close_filter).addEventListener("click", () => {
        filterModal.classList.remove("active");
      });

      document.querySelector(this.selector.overplay_filter).addEventListener("click", () => {
        filterModal.classList.remove("active");
      });

      /* Actions for Filter Item */
      var headFilter = document.querySelectorAll(
        this.selector.heading_filter_items
      );
      headFilter.forEach((head) => {
        head.addEventListener("click", function () {
          let otherChild = [...head.parentNode.children].find(
            (child) => child !== head
          );
          if (!otherChild) return;
          otherChild.parentNode.classList.toggle("active");
        });
      });

      /* Apply Filter */
      document
        .querySelector(this.selector.button_apply_filter)
        .addEventListener("click", () => {
          const formEl = document.querySelector(this.selector.forms);
          const formData = new FormData(formEl);
          this.renderFromFormData(formData);
        });

      /* Clear Filter */
      document
        .querySelector(this.selector.button_clear_filter)
        .addEventListener("click", () => {
          window.location.reload();
        });
    },
    backToTop: function () {
      if (!document.querySelector(this.selector.button_back_top)) return;
      document
        .querySelector(this.selector.button_back_top)
        .addEventListener("click", () => {
          window.scrollTo(0, 0);
        });
    },
    initLoadMore: function () {
      const self = this;
      let isLoad = false;

      window.addEventListener("scroll", function (e) {
        var scroll_top = this.scrollY;
        var load_more = document.querySelector(self.selector.load_more_container);
        if (!load_more) return;

        var load_more_top = document.querySelector(self.selector.load_more_container).getBoundingClientRect().y;
        if (scroll_top > load_more_top && !isLoad) {
          isLoad = true;
          const currentPage = document.querySelector(self.selector.load_more_container).getAttribute("data-url");
          const url = `${window.location.pathname}?section_id=${self.config.section_id}&page=${currentPage}`;
          fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
              document.querySelector(self.selector.load_more_container).remove();
              const html = responseText;
              self.renderProductItemsContainer(html, false);
              isLoad = false;
              self.backToTop();
            });
        }
      });
    },
    renderFromFormData: function (formData) {
      const searchParams = new URLSearchParams(formData);
      this.renderCollectionPage(searchParams);
    },
    renderCollectionPage: function (searchParams, updateURLHash = true) {
      const url = `${window.location.pathname}?section_id=${this.config.section_id}&${searchParams}`;

      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          this.renderProductItemsContainer(html);
          this.renderProductCount(html);
        });
    },
    renderProductItemsContainer: function (html, change = true) {
      var domProductContainer = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(this.selector.product_container).innerHTML;
      if (change)
        document.querySelector(this.selector.product_container).innerHTML =
          domProductContainer;
      else
        document.querySelector(this.selector.product_container).innerHTML +=
          domProductContainer;

      const filterModal = document.getElementById(
        `${this.selector.modal}-${this.config.section_id}`
      );
      filterModal.classList.remove("active");
    },
    renderProductCount: function (html, change = true) {
      var domProductContainer = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(this.selector.count_container).innerHTML;

      document.querySelector(this.selector.count_container).innerHTML =
        domProductContainer;
    },
  };


  /*============================================================================
    Product Template
  ==============================================================================*/
  ThemeFunc.VariantAvailability = {
    initial: true,
    classes: {
      disabled: "disabled",
      hidden: "hidden",
      onSale: "on_sale"
    },
    init: function (option, init) {
      this.containerEl = option.containerEl;
      this.variantSelected = option.variantSelected;
      this.variantsObject = option.variantsObject;
      this.selectors = option.selectors,
        this.initial ? this.setInitialAvailability() : this.setAvailability();
      this.initial = false;
    },
    setInitialAvailability: function () {
      this.containerEl.querySelectorAll(this.selectors.optionSelectors).forEach((group) => { this.disableVariantGroup(group) });

      const currentlySelectedValues = this.variantsObject[0].options.map((value, index) => {
        return { value, index: `option${index + 1}` };
      });
      const initialOptions = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues);

      for (var [option, values] of Object.entries(initialOptions)) this.manageOptionState(option, values);
    },
    setAvailability: function () {
      const currentlySelectedValues = this.variantSelected.options.map((value, index) => {
        return { value, index: `option${index + 1}` };
      });
      const valuesToManage = this.createAvailableOptionsTree(this.variantsObject, currentlySelectedValues);
      for (var [option, values] of Object.entries(valuesToManage)) {
        this.manageOptionState(option, values);
      }
    },
    manageOptionState: function (option, values) {
      var group = this.containerEl.querySelector(`${this.selectors.optionSelectors}[data-index="${option}"]`);

      // Loop through each option value
      values.forEach((obj) => {
        this.enableVariantOption(group, obj);
      });
    },
    enableVariantOption: function (group, obj) {
      var value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1");
      var buttonGroup = group.querySelector(
        `${this.selectors.optionSelectorBox}[data-value="${value}"]`
      );
      var input = buttonGroup.querySelector("input");
      var label = buttonGroup.querySelector("label");

      // Variant exists - enable & show variant
      input.classList.remove(this.classes.disabled);
      label.classList.remove(this.classes.disabled);

      // Variant sold out - cross out option (remains selectable)
      if (obj.soldOut) {
        input.classList.add(this.classes.disabled);
        label.classList.add(this.classes.disabled);
      }
    },
    disableVariantGroup: function (group) {
      group.querySelectorAll("input").forEach((input) => {
        input.classList.add(this.classes.disabled);
      });
      group.querySelectorAll("label").forEach((label) => {
        label.classList.add(this.classes.disabled);
      });
    },
    createAvailableOptionsTree: function (variantsObject, currentlySelectedValues) {
      return this.variantsObject.reduce(
        (options, variant) => {
          Object.keys(options).forEach((index) => {
            if (variant[index] === null) return;
            let entry = options[index].find((option) => option.value === variant[index]);
            if (typeof entry === "undefined") {
              entry = { value: variant[index], soldOut: true };
              options[index].push(entry);
            }
            const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === "option1");
            const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === "option2");

            switch (index) {
              case "option1":
                entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                break;
              case "option2":
                if (currentOption1 && variant["option1"] === currentOption1.value)
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
              case "option3":
                if (currentOption1 && variant["option1"] === currentOption1.value && currentOption2 && variant["option2"] === currentOption2.value)
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
            }
          });
          return options;
        },
        { option1: [], option2: [], option3: [] }
      );
    },
  };

  ThemeFunc.Product = {
    status: {
      loading: false,
    },
    text: {
      soldOut: "Sold Out",
      submitButton: "Add To Cart"
    },
    classes: {
      disabled: "disabled",
      hidden: "hidden",
      onSale: "onSale"
    },
    selectors: {
      container: ".fproduct",
      allVariantsJson: "[data-all-variant-json]",
      currentVariantJson: "[data-selected-variant-json]",
      originalSelectorId: "[data-product-select]",
      optionSelectors: "[data-variant-picker-item]",
      optionSelector1: "[data-variant-picker-item][data-index=option1]",
      optionSelector2: "[data-variant-picker-item][data-index=option2]",
      optionSelector3: "[data-variant-picker-item][data-index=option3]",
      optionSelectorBox: "[data-variant-picker-item-box]",
      singleOptionSelector: "[data-variant-picker-item-input]",
      singleOptionSelectorChecked: "[data-variant-picker-item-input]:checked",
      // Gallery 
      galleryItems: '.fproduct-media-gallery-item',
      // Info
      priceBlock: "[data-product-price]",
      priceRegular: "[data-product-price] [data-product-price-regular]",
      priceRegularA11y: "[data-product-price] [data-a11y-product-price-regular]",
      priceSave: "[data-product-price] [data-product-price-save]",
      priceSaveA11y: "[data-product-price] [data-a11y-product-price-save]",
      priceUnit: "[data-product-price-unit]",
      priceUnitMoney: "[data-product-price-unit-money]",
      priceUnitBase: "[data-product-price-unit-base]",
      priceUnitA11y: "[data-a11y-product-price-unit]",
      // Main Product Id
      mainProductId: ".product-variant-id",
      // Submit Button
      submitButton: '[type="submit"]',
    },
    init: function () {
      this.variantSelected = null;
      this.variantsObject = null;
      this.containerEl = document.querySelector(this.selectors.container);
      this.optionSelectorsEl = this.containerEl.querySelectorAll(this.selectors.optionSelectors);
      this.optionSelector1El = this.containerEl.querySelector(this.selectors.optionSelector1);
      this.optionSelector2El = this.containerEl.querySelector(this.selectors.optionSelector2);
      this.optionSelector3El = this.containerEl.querySelector(this.selectors.optionSelector3);
      this.singleOptionSelectorEl = this.containerEl.querySelectorAll(this.selectors.singleOptionSelector);
      // Gallery Item 
      this.galleryItems = this.containerEl.querySelectorAll(this.selectors.galleryItems)
      // Price Main
      this.priceBlockEl = this.containerEl.querySelector(this.selectors.priceBlock);
      this.priceRegularEl = this.containerEl.querySelector(this.selectors.priceRegular);
      this.priceRegularA11yEl = this.containerEl.querySelector(this.selectors.priceRegularA11y);
      this.priceSaveEl = this.containerEl.querySelector(this.selectors.priceSave);
      this.priceSaveA11yEl = this.containerEl.querySelector(this.selectors.priceSaveA11y);
      // Price Unit
      this.priceUnitEl = this.containerEl.querySelector(this.selectors.priceUnit);
      this.priceUnitMoneyEl = this.containerEl.querySelector(this.selectors.priceUnitMoney);
      this.priceUnitBaseEl = this.containerEl.querySelector(this.selectors.priceUnitBase);
      this.priceUnitA11yEl = this.containerEl.querySelector(this.selectors.priceUnitA11y);
      // Submit button
      this.submitButton = this.containerEl.querySelector(this.selectors.submitButton);
      this.submitButtonText = this.submitButton.querySelector('span');
      // Form Main
      this.formMain = this.containerEl.querySelector("form");
      this.formMainID = this.formMain.querySelector(this.selectors.mainProductId);
      this.productSetup();
      const item = document.querySelector('.variant-picker-item[data-index="option1"] .variant-picker-item-detail label');
      // Nếu tìm thấy, kích hoạt sự kiện click
      if (item) item.click();
    },
    optionValueCompleter: function (target) {
      const currentSelectIndex = target.dataset.optionIndex;
      return Array.from(this.optionSelectorsEl).map((optionSelector, index) => {
        if (optionSelector.querySelector(`${this.selectors.optionSelectorBox} input:checked`)) {
          return optionSelector.querySelector(`${this.selectors.optionSelectorBox} input:checked`).value;
        } else {
          if (currentSelectIndex > index + 1) optionSelector.querySelector(`${this.selectors.optionSelectorBox}:first-of-type input`).checked = true
          return optionSelector.querySelector(`${this.selectors.optionSelectorBox}:first-of-type input`).value
        }
      })
    },
    getVariants: function () {
      var domVariantsJSON = this.containerEl.querySelector(this.selectors.allVariantsJson);
      if (!domVariantsJSON) return;
      this.variantsObject = JSON.parse(domVariantsJSON.innerHTML);
    },
    getVariantSelected: function (selectOptionValues) {
      var selectOptionValuesToString = selectOptionValues.join(" / ");
      return this.variantsObject.find(variant => {
        return variant.title === selectOptionValuesToString;
      })
    },
    getSelectedOptionValues: function () {
      return Array.from(this.containerEl.querySelectorAll(this.selectors.singleOptionSelectorChecked)).map(({ value }) => value);
    },
    getOptionSelectorsLength: function () {
      return this.optionSelectorsEl.length;
    },
    productSetup: function () {
      this.getVariants();
      this.initVariants();
      this.initForm();
      this.forContent();
    },
    initVariants: function () {
      this.singleOptionSelectorEl.forEach((el) => {
        el.addEventListener("change", this.onChangeVariant.bind(this));
      });
    },
    initForm: function () {
      this.formMain.addEventListener("submit", this.addToCart.bind(this));
    },
    onChangeVariant(e) {
      const target = e.target;
      var selectOptionValues = this.getSelectedOptionValues();
      var lengthOptions = this.getOptionSelectorsLength();
      if (selectOptionValues.length < lengthOptions) {
        selectOptionValues = this.optionValueCompleter(target);
      }
      this.variantSelected = this.getVariantSelected(selectOptionValues);
      if (!this.variantSelected) return;
      ThemeFunc.VariantAvailability.init({
        containerEl: this.containerEl,
        variantsObject: this.variantsObject,
        variantSelected: this.variantSelected,
        selectors: this.selectors
      });
      this.updateSelectedInput(target);
      this.updateImage(target);
      this.updateFormId(this.variantSelected);
      this.updatePrice(this.variantSelected);
      this.updatePriceUnit(this.variantSelected);
      this.updateSubmitButton(this.variantSelected);
    },
    updateFormId: function (variant) {
      if (!variant) return;
      this.formMainID.value = variant.id;
    },
    updateSelectedInput: function (target) {
      const value = target.value;
      target.closest(".variant-picker-item").querySelector("legend [data-selected-value]").innerHTML = value;
    },
    updateImage: function (target) {
      const thisStatus = this.containerEl.dataset.changeImageAlt;
      if (!thisStatus) return;
      const thisVal = target.dataset.value;
      const thisType = target.dataset.type;
      if (thisType != "color") return;
      this.galleryItems.forEach(galleryItem => {
        galleryItem.style.display = "none";
      })
      this.containerEl.querySelectorAll(`${this.selectors.galleryItems}[data-alt="${thisVal}"]`).forEach(galleryItem => {
        galleryItem.style.display = "block";
      })
      this.containerEl.querySelector("product-media")?.refreshMobileSwiper?.();
      if (window.innerWidth > 600) {
        $('product-media img').ezPlus({
          zoomType: 'inner',
          cursor: 'zoom-in'
        });
      }
    },
    updatePrice: function (variant) {
      if (!variant) return;
      this.priceSaveEl.innerHTML = ThemeFunc.Currency.formatMoney(variant.price, ThemeFunc.settings.moneyFormat)

      if (variant.compare_at_price > variant.price) {
        if (this.priceBlockEl)
          this.priceBlockEl.classList.add(this.classes.onSale);

        if (this.priceRegularEl) {
          this.priceRegularEl.innerHTML = ThemeFunc.Currency.formatMoney(variant.compare_at_price, ThemeFunc.settings.moneyFormat)
          this.priceRegularEl.classList.remove(this.classes.hidden)
        }

        if (this.priceRegularA11yEl)
          this.priceRegularA11yEl.setAttribute("aria-hidden", 'false');

        if (this.priceSaveA11yEl)
          this.priceSaveA11yEl.setAttribute("aria-hidden", 'false');
      } else {
        if (this.priceBlockEl)
          this.priceBlockEl.classList.remove(this.classes.onSale);

        if (this.priceRegularEl)
          this.priceRegularEl.classList.add(this.classes.hidden)

        if (this.priceRegularA11yEl)
          this.priceRegularA11yEl.setAttribute("aria-hidden", 'true');

        if (this.priceSaveA11yEl)
          this.priceSaveA11yEl.setAttribute("aria-hidden", 'true');
      }
    },
    updatePriceUnit: function (variant) {
      if (!variant) return;
      if (variant.unit_price) {
        if (this.priceUnitMoneyEl)
          this.priceUnitMoneyEl.innerHTML = ThemeFunc.Currency.formatMoney(variant.unit_price, ThemeFunc.settings.moneyFormat);
        if (this.priceUnitBaseEl)
          this.priceUnitBaseEl.innerHTML = ThemeFunc.Currency.getBaseUnit(variant);
        if (this.priceUnitEl)
          this.priceUnitEl.classList.remove(this.classes.hidden);
      } else this.priceUnitEl.classList.add(this.classes.hidden);
    },
    updateSubmitButton: function (variant) {
      if (!variant) return;
      if (variant.available) {
        this.submitButton.removeAttribute('disabled');
        this.submitButtonText.textContent = this.text.submitButton;
      } else {
        this.submitButton.setAttribute('disabled', 'disabled');
        this.submitButtonText.textContent = this.text.soldOut;
      }
    },
    addToCart: function (e) {
      e.preventDefault();
      if (this.status.loading) return;
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.status.loading = true;
      const cartDrawer = document.querySelector("cart-drawer");
      const formData = new FormData(this.formMain);
      if (cartDrawer) {
        formData.append(
          'sections',
          cartDrawer.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        cartDrawer.setActiveElement(document.activeElement);
      }
      const data = new URLSearchParams();
      for (const pair of formData) {
        data.append(pair[0], pair[1]);
      }

      fetch("/cart/add.js", {
        method: 'POST',
        body: data,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(response => response.json())
        .then(function (product) {
          ThemeFunc.Product.submitButton.removeAttribute("aria-disabled")
          ThemeFunc.Product.submitButton.classList.remove('loading');
          ThemeFunc.Product.status.loading = false;
          cartDrawer.classList.remove("is-empty");
          cartDrawer.renderContents(product)
        })
    },
    forContent: function () {
      var itemFilter = document.querySelectorAll(".fproduct-info-des-item");
      var headFilter = document.querySelectorAll(".fproduct-info-des-item-head");
      var buttonCloseFilter = document.querySelectorAll(`button[data-type="close-description"]`);
      headFilter.forEach((head) => {
        head.addEventListener("click", function () {
          let otherChild = [...head.parentNode.children].find(
            (child) => child !== head
          );
          if (!otherChild) return;
          let otherParent = [...head.parentNode.parentNode.children].filter(
            (parent) => parent !== head.parentNode
          );
          if(otherParent.length > 0) otherParent.forEach((parent) => { parent.classList.remove("active"); })
          otherChild.parentNode.classList.toggle("active");
        });
      });

      buttonCloseFilter.forEach((button) => {
        button.addEventListener("click", function () {
          itemFilter.forEach((item) => { item.classList.remove("active"); })
        });
      });
    },
  };
  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready 
  ==============================================================================*/
  ThemeFunc.Utils.readyDOM(function () {
    if (window.ThemeFunc.settings.template.includes("collection")) ThemeFunc.Collection.init();
    if (window.ThemeFunc.settings.template.includes("product")) ThemeFunc.Product.init();
  });
  /*============================================================================
    End Func
  ==============================================================================*/
})();
